module.exports = __webpack_public_path__ + "img/marketRadar.60f52e8b.jpg";